
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from '../../Dashboard/_services/users.service';

export const authGuard = () => {
  const userService = inject(UserService);
  const router = inject(Router);
  const userInfo = userService.isLoggedIn();
  if (userInfo.isLoggedIn) {
    return true;
  } else {
    return router.navigate(['/login']);
  }
};